export default ({ request }) => ({
  ecomAmzSkuInvFtyLogListApi(data = {}) {
    return request({
      url: '/ecom/amz/sku/inv/fty/log/list',
      method: 'POST',
      data,
    })
  },
})
